import env from "../env";
import axios from "./httpClient";

export function getApplicantByIdApi(id, params, api = "") {
  return axios.get(`/${api}/applicant/${id}`, { params });
}
export function getApplicantLogsApi(id, api = "") {
  return axios.get(`/${api}/applicant/${id}/logs`);
}
export function getApplicantErrorsApi(id, api = "") {
  return axios.get(`/${api}/applicant/${id}/errors`);
}
export function getApplicantLastError(id, api = "") {
  return axios.get(`/${api}/applicant/${id}/last-error`);
}
export function getApplicantEmailsApi(id, api = "") {
  return axios.get(`/${api}/applicant/${id}/emails`);
}
export function updateApplicantApi(id, applicant, api = "", disableValidation) {
  return axios.put(`/${api}/applicant/${id}`, {
    ...applicant,
    disableValidation,
  });
}

export function changeApplicantType(
  id,
  applicationType,
  mainApplicationId,
  api = "",
) {
  return axios.post(`/${api}/applicant/${id}/application_type`, {
    applicationType,
    mainApplicationId,
  });
}

export function partyiallyUpdateApplicantApi(id, partialApplicant, api = "") {
  return axios.patch(`/${api}/applicant/${id}`, partialApplicant);
}

export function reassignZendeskAssignmentApi(
  id,
  { zendeskId, zendeskInstance },
  api = "",
) {
  return axios.put(`/${api}/applicant/${id}/zendesk-assignment`, {
    zendeskId,
    zendeskInstance,
  });
}

export function deleteApplicantApi(id, api = "") {
  return axios.delete(`/${api}/applicant/${id}`);
}

export function changePaymentStatusApi(id, status, api = "", orderId) {
  return axios.post(`/${api}/applicant/${id}/payment_status`, {
    status,
    orderId,
  });
}

export function changePhoneNumbers(id, phoneNumbers, api = "") {
  return axios.post(`/${api}/applicant/${id}/phone_numbers`, phoneNumbers);
}

export function changeStatusApi(id, status, api = "") {
  return axios.post(`/${api}/applicant/${id}/status`, { status });
}

export function changeFailsafeImmunity(id, failsafeImmunity, api = "") {
  return axios.post(`/${api}/applicant/${id}/immunity`, { failsafeImmunity });
}

export function runBotApi(id, api = "", payload = {}) {
  return axios.post(`/${api}/applicant/${id}/run`, payload);
}

export function allowDs82BotReprocessApi(id, reason) {
  return axios.post(`/ds82/applicant/${id}/allow-bot-reprocess`, {
    reason,
    runBot: true,
  });
}

export function runPaymentBotApi(id, api = "") {
  return axios.post(`/${api}/applicant/${id}/run-payment`);
}

export function removeBotRunApi(id, api = "") {
  return axios.delete(`/${api}/applicant/${id}/run`);
}

export function runEmbassyBotApi(id, api = "") {
  return axios.post(`/${api}/applicant/${id}/run/embassy`);
}

export function removeEmbassyBotRunApi(id, api = "") {
  return axios.delete(`/${api}/applicant/${id}/run/embassy`);
}

export function getApplicantsApi(params, api = "") {
  return axios.get(`/${api}/applicant`, { params });
}

export function checkStatusApi(id, api = "") {
  return axios.post(`/${api}/applicant/${id}/check-status`);
}

export function continueApplicantApi(id, api = "") {
  return axios.post(`/${api}/applicant/${id}/continue`);
}

export function overrideApplicantApi(id, api = "") {
  return axios.post(`/${api}/applicant/${id}/override`);
}

export function changeApplicantStatusToPaymentFailed(id, api = "") {
  return axios.post(`/${api}/applicant/${id}/status`, { status: 29 });
}

export function uploadApplicantFileApi(id, api, fileType, body) {
  return axios.post(`/${api}/applicant/${id}/upload/${fileType}`, body);
}

export function refundApplicantsPaymentApi(
  id,
  api,
  orderId,
  refundAmount,
  reason,
) {
  return axios.post(`/${api}/applicant/${id}/invoices/${orderId}/refund`, {
    refundAmount,
    reason,
  });
}

export function changeScheduleStatusApi(id, api) {
  return axios.post(`/${api}/applicant/${id}/schedule_status`);
}

export function resendPhotoToolEmailApi(id, api) {
  return axios.post(`/${api}/applicant/${id}/photo-tool/resend`);
}

export function getGroupApplicants(id, api) {
  return axios.get(`/${api}/applicant/${id}/group-info`);
}

export function getDeclarationsApi(id) {
  return axios.get(`/review-and-certification/check-texts-ucc/${id}`);
}

export function submitIVisa(id) {
  return axios.post(`/esta/ivisa/${id}`);
}

export function cancelIVisa(id) {
  return axios.post(`/esta/ivisa/${id}/cancel`);
}

export function captureAuthorizationApi(id, api, orderId, amount) {
  return axios.post(`/${api}/applicant/${id}/capture-authorization`, {
    orderId,
    amount,
  });
}

export function cancelAuthorizationApi(id, api, orderId) {
  return axios.post(`/${api}/applicant/${id}/cancel-authorization`, {
    orderId,
  });
}

export function refundTransactionApi(id, api, orderId, amount) {
  return axios.post(`/${api}/applicant/${id}/refund-transaction`, {
    orderId,
    amount,
  });
}

export function validateApplicationApi(id, api) {
  return axios.post(
    `/${api}/applicant/${id}/validate`,
    { id, api },
    {
      timeout: 30000,
    },
  );
}

export function generatePassportAppointmentOptionsApi(id, api) {
  return axios.post(
    `/${api}/applicant/${id}/generate-passport-appointment-options`,
    { id, api },
    {
      timeout: 30000,
    },
  );
}

export function convertPassportApplicationApi(id, api) {
  return axios.post(
    `/${api}/applicant/${id}/convert-passport-application`,
    { id, api },
    {
      timeout: 30000,
    },
  );
}

export function getPortraitPictures(id, api) {
  return axios.get(
    `/${api}/applicant/${id}/portrait-pictures`,
    { id, api },
    {
      timeout: 30000,
    },
  );
}

export function getApplicantNotes(applicantId, filter) {
  return axios.get(
    `/applicant-notes/applicant/${applicantId}${filter ? `?${filter}` : ""}`,
    {
      timeout: 30000,
    },
  );
}

export function getApplicantPinnedNotesApi(applicantId) {
  return axios.get(`/applicant-notes/${applicantId}/pinned`);
}

export function createApplicantNote(payload) {
  return axios.post("/applicant-notes", payload);
}

export function pinApplicantNote(noteId, payload) {
  return axios.put(`/applicant-notes/${noteId}/pin`, payload);
}

export function passportsSelectPortrait(id, api, payload) {
  return axios.post(`/${api}/applicant/${id}/select-photo`, payload);
}

export function fetchOrderInformation(id, api, orderId) {
  return axios.post(
    `/${api}/applicant/${id}/fetch-order-information`,
    { orderId },
    {
      timeout: 30000,
    },
  );
}

export function addPurchase(id, api, orderId) {
  return axios.post(
    `/${api}/applicant/${id}/add-purchase`,
    { orderId },
    {
      timeout: 30000,
    },
  );
}

export function generateTempGlobalEntryApi(id, api) {
  return axios.post(`/${api}/applicant/${id}/generate-temp-global-entry`, {
    id,
    api,
  });
}

export function uploadPassportPortrait(id, api, body) {
  return axios.post(`/${api}/applicant/${id}/upload-portrait-picture`, body);
}

export function forceReSyncApi(id, api, applicationData) {
  return axios.post("/olympus/webhook/send-notification", {
    reason: "submitted",
    application: api,
    data: applicationData,
  });
}

// Charge Fee and the government fee payment link price the same product and upsells.
function buildFeePayload(selectedProduct = {}) {
  const { id: productId, price: productPrice = 0 } = selectedProduct;
  const payload = { productId };

  const upsellIds = [];

  // Always include forced upsells if configured
  const forceUpsellIds = env.FORCE_GOVFEE_UPSELL_IDS;
  if (forceUpsellIds) {
    upsellIds.push(...forceUpsellIds.split(',').map(id => id.trim()));
  }

  // Include handling fee upsell if product price exceeds threshold
  const handlingFeeUpsellId = env.HANDLING_FEE_UPSELL_ID;
  const handlingFeeThreshold = env.HANDLING_FEE_THRESHOLD;

  if (handlingFeeUpsellId && productPrice >= handlingFeeThreshold) {
    upsellIds.push(handlingFeeUpsellId.trim());
  }

  if (upsellIds.length > 0) {
    // Remove duplicates and join as comma-separated string
    payload.upsellIds = [...new Set(upsellIds)].join(',');
  }

  return payload;
}

export function chargeFeeApi(id, api, selectedProduct) {
  return axios.post(
    `/${api}/applicant/${id}/charge-fee`,
    buildFeePayload(selectedProduct),
  );
}

// Asks etaapi for a signed link the customer uses to pay the government fee themselves.
export function createGovFeePaymentLinkApi(id, api, selectedProduct) {
  return axios.post(
    `/${api}/applicant/${id}/gov-fee-payment-link`,
    buildFeePayload(selectedProduct),
  );
}

export function getChargableFeesApi(id, api) {
  return axios.get(`/${api}/applicant/${id}/products`);
}
export function getApplicantPurchasesApi(id, api) {
  return axios.get(`/${api}/applicant/${id}/purchases`);
}

export function triggerPassportStatusCheck(id, api) {
  return axios.post(`/passport-status-checker/check/${id}`, {
    applicantType: api,
  });
}
